import { STARTAPI_REQUEST_UNSEAL, SENDAPI_REQUEST_UNSEAL } from './constants'
const initialState = {
  data: '',
}
export const resultStartApiReqUnseal = (state = initialState, action) => {
  switch (action.type) {
    case STARTAPI_REQUEST_UNSEAL:
      return {
        ...state,
        data: action.message,
      }
    case SENDAPI_REQUEST_UNSEAL:
      return {
        ...state,
        data: action.message,
      }
    default:
      return state
  }
}
